module.exports = __webpack_public_path__ + "img/product_item_bg1.87c6cefd.png";